module.exports = __webpack_public_path__ + "static/media/_info.634597a2.svg";